import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/frontend/src/app/contact/ContactMailCard.tsx");
